<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <!-- 搜索条件 -->
      <a-form-model layout="inline" :model="queryParam">
        <a-form-model-item label="经销商ID">
          <a-input
            v-model="queryParam.user_id"
            placeholder="请输入经销商ID"
            style="width: 150px"
          />
        </a-form-model-item>
        <a-form-model-item label="客户ID">
          <a-input
            v-model="queryParam.vf_user_id"
            placeholder="请输入客户ID"
            style="width: 150px"
          />
        </a-form-model-item>
        <a-form-model-item label="奖品">
          <a-select
            v-model="queryParam.prize_id"
            placeholder="请选择奖品"
            allowClear
            style="width: 150px"
          >
            <a-select-option
              v-for="item in prizeList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.prize_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="使用状态">
          <a-select
            v-model="queryParam.used"
            placeholder="请选择"
            allowClear
            style="width: 120px"
          >
            <a-select-option value="0">未使用</a-select-option>
            <a-select-option value="1">已使用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="核销抽奖时间">
          <a-range-picker
            v-model="drawDateRange"
            @change="onDrawDateChange"
            style="width: 220px"
          />
        </a-form-model-item>
        <a-form-model-item label="使用时间">
          <a-range-picker
            v-model="useDateRange"
            @change="onUseDateChange"
            style="width: 220px"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="resetSearch"
            >重置</a-button
          >
        </a-form-model-item>
      </a-form-model>

      <!-- 表格 -->
      <a-table
        class="mt10"
        ref="table"
        size="middle"
        :columns="columns"
        :dataSource="data"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        rowKey="id"
      >
        <span slot="prize_info" slot-scope="text, record">
          <div style="display: flex; align-items: center">
            <img
              :src="IMGHOST + record.prize_image"
              style="
                width: 160px;
                height: 60px;
                margin-right: 8px;
                object-fit: cover;
                cursor: pointer;
              "
              v-if="record.prize_image"
              @click="toDetail(record)"
            />
            <span>{{ record.prize_name }}</span>
          </div>
        </span>
        <span slot="use_status" slot-scope="text">
          <a-tag :color="text == 1 ? 'green' : 'orange'">
            {{ text == 1 ? "已使用" : "未使用" }}
          </a-tag>
        </span>
        <span slot="prize_type" slot-scope="text">
          {{ getPrizeType(text) }}
        </span>
        <span slot="user_name" slot-scope="text, record">
          {{ record.user ? record.user.name : "-" }}
        </span>
      </a-table>
      <a-modal
        title="图片展示"
        :visible="showImgStatus"
        :footer="null"
        @cancel="showImgStatus = false"
        :width="400"
      >
        <img style="width: 100%" :src="currentImg" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  VfPrizeRecord_index,
  VfPrizeRecord_prizeList,
} from "@/api/vfPrizeRecord";

export default {
  name: "VfPrizeRecord",
  data() {
    return {
      IMGHOST: window.IMGHOST,
      queryParam: {},
      drawDateRange: [],
      useDateRange: [],
      prizeList: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          width: 80,
        },
        {
          title: "奖品信息",
          scopedSlots: { customRender: "prize_info" },
        },
        {
          title: "奖品类型",
          dataIndex: "prize_type",
          scopedSlots: { customRender: "prize_type" },
          width: 100,
        },
        {
          title: "经销商",
          dataIndex: "user_name",
          scopedSlots: { customRender: "user_name" },
          width: 100,
        },
        {
          title: "客户ID",
          dataIndex: "vf_user_id",
          width: 100,
        },
        {
          title: "兑换码",
          dataIndex: "code",
          width: 150,
        },
        {
          title: "抽奖时间",
          dataIndex: "draw_time",
          width: 180,
        },
        {
          title: "过期时间",
          dataIndex: "expire_time",
          width: 180,
        },
        {
          title: "使用状态",
          dataIndex: "use_status",
          scopedSlots: { customRender: "use_status" },
          width: 100,
        },
      ],
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      loading: false,
      showImgStatus: false,
      currentImg: "",
    };
  },
  created() {
    this.getPrizeList();
    this.loadData();
  },
  methods: {
    getPrizeList() {
      VfPrizeRecord_prizeList().then((res) => {
        // 根据返回结构调整
        this.prizeList = res.result || res || [];
      });
    },
    loadData() {
      this.loading = true;
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        ...this.queryParam,
      };
      VfPrizeRecord_index(params)
        .then((res) => {
          const result = res.result || res;
          if (result && result.list) {
            this.data = result.list;
            // 尝试获取总数，如果没有则设为0或列表长度（虽然这不准确）
            this.pagination.total = result.count || result.total || 0;
          } else {
            this.data = [];
            this.pagination.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.data = [];
        });
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadData();
    },
    handleSearch() {
      this.pagination.current = 1;
      this.loadData();
    },
    resetSearch() {
      this.queryParam = {};
      this.drawDateRange = [];
      this.useDateRange = [];
      this.handleSearch();
    },
    onDrawDateChange(dates, dateStrings) {
      this.queryParam.draw_start_time = dateStrings[0];
      this.queryParam.draw_end_time = dateStrings[1];
    },
    onUseDateChange(dates, dateStrings) {
      this.queryParam.use_start_time = dateStrings[0];
      this.queryParam.use_end_time = dateStrings[1];
    },
    getPrizeType(type) {
      const map = {
        1: "实物",
        2: "优惠券",
        3: "会员权益",
      };
      return map[type] || "未知";
    },
    toDetail(record) {
      this.currentImg = this.IMGHOST + record.prize_image;
      this.showImgStatus = true;
    },
  },
};
</script>

<style scoped>
.mt10 {
  margin-top: 10px;
}
</style>
